import { useMutation } from "react-query";
import { addOnlineDirectories } from "../../../../../actions/Utilities/OnlineDirectories";
import { toast } from "components/toastNotification";
import { IOnlineDirectories } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateOnlineDirectories,
  onlineDirectoriesReFetching,
} from "../atoms/atoms";

const useAddOnlineDirectories = () => {
  const setIsAddState = useSetRecoilState(addStateOnlineDirectories);
  const [isReFetching, setIsReFetching] = useRecoilState(
    onlineDirectoriesReFetching
  );

  const { mutate } = useMutation(
    (NewData: IOnlineDirectories) => addOnlineDirectories(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Online Directory Brand failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Online Directory Brand Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Online Directory Brand Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Online Directory Brand failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Online Directory Brand failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Online Directory Brand failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Online Directory Brand failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddOnlineDirectories;
